import dayjs from "dayjs";

export function formatFlexibleTime(timeString) {
  let parsedTime;

  if (timeString.includes(".")) {
    // Trim to milliseconds if microseconds are present
    const trimmed = timeString.replace(
      /^(\d{2}:\d{2}:\d{2})\.(\d{3})\d*$/,
      "$1.$2"
    );
    parsedTime = dayjs(trimmed, "HH:mm:ss.SSS");
  } else {
    // Just parse normally
    parsedTime = dayjs(timeString, "HH:mm:ss");
  }

  // Check for invalid date
  if (!parsedTime.isValid()) {
    return "Invalid time";
  }

  return parsedTime.format("HH:mm:ss");
}
